import { render, staticRenderFns } from "./adm_srch_results.vue?vue&type=template&id=28e77250&scoped=true&"
import script from "./adm_srch_results.vue?vue&type=script&lang=js&"
export * from "./adm_srch_results.vue?vue&type=script&lang=js&"
import style0 from "./adm_srch_results.vue?vue&type=style&index=0&id=28e77250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e77250",
  null
  
)

export default component.exports